import { Repository } from "./adapters/repository";

import * as createVideoConferenceCall from "./useCases/createVideoConferenceCall";
import * as retrieveVideoConferenceCallLinks from "./useCases/retrieveVideoConferenceCallLinks";

enum UseCases {
  createVideoConferenceCall = "createVideoConferenceCall",
  retrieveVideoConferenceCallLinks = "retrieveVideoConferenceCallLinks",
}

interface Core {
  [UseCases.createVideoConferenceCall]: createVideoConferenceCall.Interactor;
  [UseCases.retrieveVideoConferenceCallLinks]: retrieveVideoConferenceCallLinks.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.createVideoConferenceCall]:
      createVideoConferenceCall.createInteractor(dependencies.repository),
    [UseCases.retrieveVideoConferenceCallLinks]:
      retrieveVideoConferenceCallLinks.createInteractor(
        dependencies.repository,
      ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
